
import dayjs from 'dayjs'
import { TextField, IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import useInvoiceBillStyles from '../styles'
import LogoP1 from '../../../../../assets/images/logomain.png'
import numberToWords from 'number-to-words'
import currencyCodes from 'currency-codes'
import EditableDate from '../utils/EditableDate '
import EditableDueDate from '../utils/EditableDueDate'
import OmDetailsPage from './OmDetailsPage'

// O&M Details Page Component

// Main Invoice Table Component
const InvoiceTable = ({
  energyValu,
  setEnergyValu,
  mainEnergy,
  setMainEnergy,
  totals,
  setMainTariff,
  mainTariff,
  state,
  invoiceDate,
  handleEditClick,
  energyValue,
  deemedEnergy,
  setDeemedEnergy,
  deemedTariff,
  setDeemedTariff,
  deemedGeneration, // Keep this for backward compatibility
  deemedGener, // ✅ NEW - This is the editable state value
  setDeemedGener, // ✅ NEW - This is the setter function
  omAmounts,
  setOmAmounts,
  months,
  firstDate,
  setFirstDate,
  dueDate,
  setDueDate,
  invoiceDetails,
  zohoState,
  zohoinvoicenumber,
  billingRecord, //Billing record for syncing
}) => {
  // ...existing code...

  const classes = useInvoiceBillStyles()

  // console.log('zohoStateggg', zohoState)

  const today = new Date(invoiceDate)
  const CurrentMonth1 = today.getMonth() // Get current month (0-indexed)

  const FetchCurrency = (currency) => {
    if (currency === 'INR') return '₹'
    else if (currency === 'USD') return '$'
    return currency
  }

  const getCurrencyFullName = (currencyCode) => {
    const currency = currencyCodes.code(currencyCode)
    return currency ? currency.currency : 'Unknown Currency'
  }

  // Helper function to handle positive number input
  const handlePositiveNumberChange = (value, setter) => {
    const numValue = parseFloat(value)
    if (value === '' || (!isNaN(numValue) && numValue >= 0)) {
      setter(value)
    }
  }

  // Helper function to prevent negative input on keydown
  const handleKeyDown = (e) => {
    // Prevent minus key, but allow backspace, delete, tab, escape, enter, and arrow keys
    if (e.key === '-' || e.key === 'Minus') {
      e.preventDefault()
    }
  }

  // Helper function to prevent scroll wheel from changing number input values
  const handleWheel = (e) => {
    // Prevent wheel events only if the target is a number input
    if (e.target.type === 'number') {
      e.preventDefault()
      // Optionally blur the input to remove focus
      e.target.blur()
    }
  }

  // Format a numeric input to show decimals only when they exist
  const formatToTwoDecimals = (value) => {
    if (value === '' || value === null || value === undefined) return '0'
    const num = Number(value)
    if (isNaN(num)) return '0'
    // If it's zero, return '0'
    if (num === 0) return '0'
    // Only show decimals if the number has a fractional part
    return num % 1 === 0 ? num.toString() : num.toFixed(2)
  }

  // Get billing address from state or Zoho
  const getBillingAddress = () => {
    return (
      zohoState?.latestInvoiceBillingAddress ||
      state?.data?.clientDetails?.billerDetails?.billToAddress ||
      ''
    )
  }

  // Format address parts for display
  const formatAddressDisplay = (parts) => {
    return (
      <>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 'bold',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            color: '#1b6de0',
            marginBottom: '8px',
          }}
        >
          {state?.data?.plantName || ''}
        </div>
        <div
          style={{
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            lineHeight: '1.5',
          }}
        >
          {parts.slice(0, 4).join(', ')}
        </div>
        {customerhasGSTN && (
          <div
            style={{
              marginTop: '8px',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            GSTIN: {zohoState?.customerGstNo || ''}
          </div>
        )}
      </>
    )
  }

  // Render address section based on address parts length
  const renderAddressSection = () => {
    const address = getBillingAddress()
    const parts = address.split(',')

    if (parts.length > 2) {
      return formatAddressDisplay(parts)
    }

    return address
  }

  // Check if location is matched for tax display
  // const isLocationMatched = zohoState?.isLocationMatched === true
  const isLocationMatched = false

  console.log('CGST SGST IGST Check - isLocationMatched:', isLocationMatched)
  console.log(zohoState, 'zohoState')

  const isEMIType = state?.data?.proposalType?.type === 'EMI'

  // Check if GST should be hidden
  const customerhasGSTN =
    zohoState?.customerGstNo &&
    zohoState.customerGstNo.trim() !== '' &&
    zohoState.customerGstNo !== null &&
    zohoState.customerGstNo !== undefined &&
    zohoState.customerGstNo !== 'N/A'

  const hasGSTN =
    zohoState?.organizationGstNo &&
    zohoState.organizationGstNo.trim() !== '' &&
    zohoState.organizationGstNo !== null &&
    zohoState.organizationGstNo !== undefined &&
    zohoState.organizationGstNo !== 'N/A'

  // Calculate rounding amount and rounded total
  const subTotal = isEMIType ? totals.totaltarif || 0 : totals.totalAmount || 0
  const roundedTotal = Math.round(subTotal)
  const roundingAmount = roundedTotal - subTotal

  return (
    <>
      <div
        className={`${classes.containerNewStyle} print-no-border`}
        id="divToPrint"
      >
        <div
          style={{
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <img
              style={{ height: 70, width: 150 }}
              src={LogoP1}
              alt="DE logo1"
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                {zohoState?.organizationName || ''}
              </div>
              <div style={{ fontSize: '16px' }}>
                {zohoState?.orgAddress || ''}
              </div>
              {hasGSTN && (
                <div style={{ fontSize: '16px' }}>
                  GSTIN: {zohoState?.organizationGstNo || ''}
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              justifyContent: 'space-between',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <div style={{ fontSize: '20px', color: 'gray' }}>
              Distributed Energy
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
              TAX INVOICE
            </div>
          </div>
        </div>

        <table className={`${classes.tableStyle} print-no-border`}>
          <tbody>
            <tr>
              <td>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div className={classes.tophstyle}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div style={{ minWidth: '50%' }}>Invoice</div>
                      <div
                        md={4}
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                      >
                        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                          : {zohoinvoicenumber}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div style={{ minWidth: '50%' }}>Invoice Date</div>
                      <EditableDate
                        firstDate={firstDate}
                        setFirstDate={setFirstDate}
                        invoiceDetails={invoiceDetails}
                        invoiceDate={invoiceDate}
                        billingRecord={billingRecord}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div style={{ minWidth: '50%' }}>Due Date</div>
                      <EditableDueDate
                        dueDate={dueDate}
                        setDueDate={setDueDate}
                        invoiceDetails={invoiceDetails}
                        paymentTermsDays={state?.data?.paymentTermsDays}
                        billingRecord={billingRecord}
                        invoiceDate={firstDate}
                      />
                    </div>
                  </div>
                  <div className={classes.tophstyle}>
                    <div>
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ minWidth: '50%' }}>Plant Name</div>
                        <div
                          style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                          }}
                        >
                          : {state?.data?.plantName || ''}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: '8px',
                      }}
                    >
                      <div style={{ minWidth: '50%' }}>Solar Plant Size</div>
                      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        : ({state?.data?.plantSize}kWp)
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className={classes.tdStyle}>
                  <div container>
                    <div
                      style={{
                        width: '100%',
                        display: 'block',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '16px',
                          wordWrap: 'break-word',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal',
                          lineHeight: '1.5',
                        }}
                      >
                        {renderAddressSection()}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className={classes.tdStyle}>
                  <div container>
                    <div>
                      <div>Subject :</div>
                      <div>
                        Summary of Charges for {months[CurrentMonth1]}{' '}
                        {dayjs(invoiceDate).format('YYYY')}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <table
                  className={`${classes.tableStyle} print-no-border`}
                  style={{ width: '100%', tableLayout: 'fixed' }}
                >
                  <thead>
                    <tr>
                      <th
                        className={classes.thStyle}
                        rowSpan={2}
                        style={{ width: '5%' }}
                      >
                        #
                      </th>
                      <th
                        className={classes.thStyle}
                        rowSpan={2}
                        style={{ width: hasGSTN ? '25%' : '35%' }}
                      >
                        Item & Description
                      </th>
                      {hasGSTN && (
                        <th
                          className={classes.thStyle}
                          rowSpan={2}
                          style={{ width: '12%' }}
                        >
                          HSN/SAC
                        </th>
                      )}
                      <th
                        className={classes.thStyle}
                        rowSpan={2}
                        style={{ width: hasGSTN ? '12%' : '20%' }}
                      >
                        Energy (kWh)
                      </th>
                      <th
                        className={classes.thStyle}
                        rowSpan={2}
                        style={{ width: hasGSTN ? '12%' : '20%' }}
                      >
                        {isEMIType ? 'Tariff' : 'Tariff'}
                      </th>

                      {/* Tax columns - only show if GSTN exists */}
                      {hasGSTN && (
                        <>
                          {isLocationMatched ? (
                            <>
                              <th
                                className={classes.thStyleRow}
                                colSpan={2}
                                style={{ width: '12%' }}
                              >
                                CGST
                              </th>
                              <th
                                className={classes.thStyleRow}
                                colSpan={2}
                                style={{ width: '12%' }}
                              >
                                SGST
                              </th>
                            </>
                          ) : (
                            <th
                              className={classes.thStyleRow}
                              colSpan={2}
                              style={{ width: '12%' }}
                            >
                              IGST
                            </th>
                          )}
                        </>
                      )}

                      {/* Amount column for non-EMI */}
                      {!isEMIType && (
                        <th
                          className={classes.thStyle}
                          rowSpan={2}
                          style={{ width: '12%' }}
                        >
                          Amount
                        </th>
                      )}
                    </tr>
                    <tr>
                      {/* Tax sub-headers - only show if GSTN exists */}
                      {hasGSTN && (
                        <>
                          {isLocationMatched ? (
                            <>
                              <th
                                className={classes.thStyleRow}
                                style={{ width: '6%' }}
                              >
                                %
                              </th>
                              <th
                                className={classes.thStyleRow}
                                style={{ width: '6%' }}
                              >
                                Amt
                              </th>
                              <th
                                className={classes.thStyleRow}
                                style={{ width: '6%' }}
                              >
                                %
                              </th>
                              <th
                                className={classes.thStyleRow}
                                style={{ width: '6%' }}
                              >
                                Amt
                              </th>
                            </>
                          ) : (
                            <>
                              <th
                                className={classes.thStyleRow}
                                style={{ width: '6%' }}
                              >
                                %
                              </th>
                              <th
                                className={classes.thStyleRow}
                                style={{ width: '6%' }}
                              >
                                Amt
                              </th>
                            </>
                          )}
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {/* Row 1 - Main Energy */}
                    <tr>
                      <td className={classes.tdStyle}>1</td>
                      <td
                        className={classes.tdStyle}
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
                      >
                        {state?.data?.plantName} ({state?.data?.plantSize}kWp)
                      </td>
                      {hasGSTN && (
                        <td
                          className={classes.tdStyle}
                          style={{ fontSize: '16px', fontWeight: 'normal' }}
                        >
                          27160000
                        </td>
                      )}
                      <td className={classes.tdStyle}>
                        {energyValue !== null ? energyValu : mainEnergy}
                      </td>
                      <td className={classes.tdStyle}>
                        {mainTariff}
                      </td>

                      {/* Tax columns for Row 1 - only show if GSTN exists */}
                      {hasGSTN && (
                        <>
                          {isLocationMatched ? (
                            <>
                              <td className={classes.tdStyle}>
                                0.00
                              </td>
                              <td className={classes.tdStyle}>
                                {totals.cgstAmount
                                  ? totals.cgstAmount.toFixed(2)
                                  : '0.00'}
                              </td>
                              <td className={classes.tdStyle}>
                                0.00
                              </td>
                              <td className={classes.tdStyle}>
                                {totals.sgstAmount
                                  ? totals.sgstAmount.toFixed(2)
                                  : '0.00'}
                              </td>
                            </>
                          ) : (
                            <>
                              <td className={classes.tdStyle}>
                                0.00
                              </td>
                              <td className={classes.tdStyle}>
                                {totals.cgstAmount && totals.sgstAmount
                                  ? (
                                      totals.cgstAmount + totals.sgstAmount
                                    ).toFixed(2)
                                  : '0.00'}
                              </td>
                            </>
                          )}
                        </>
                      )}

                      {/* Amount column for non-EMI Row 1 */}
                      {!isEMIType && (
                        <td className={classes.tdStyle}>
                          {totals.mainAmount
                            ? totals.mainAmount.toFixed(2)
                            : '0.00'}
                        </td>
                      )}
                    </tr>

                    {/* Row 2 - Deemed Generation */}
                    <tr>
                      <td className={classes.tdStyle}>2</td>
                      <td className={classes.tdStyle}>Deemed Generation</td>
                      {hasGSTN && (
                        <td
                          className={classes.tdStyle}
                          style={{ fontSize: '16px', fontWeight: 'normal' }}
                        >
                          27160000
                        </td>
                      )}
                      <td className={classes.tdStyle}>
                        {deemedEnergy}
                      </td>
                      <td className={classes.tdStyle}>
                        {deemedTariff}
                      </td>

                      {/* Tax columns for Row 2 - only show if GSTN exists */}
                      {hasGSTN && (
                        <>
                          {isLocationMatched ? (
                            <>
                              <td className={classes.tdStyle}>
                                0.00
                              </td>
                              <td className={classes.tdStyle}>
                                {totals.deemedCgstAmount
                                  ? totals.deemedCgstAmount.toFixed(2)
                                  : '0.00'}
                              </td>
                              <td className={classes.tdStyle}>
                                0.00
                              </td>
                              <td className={classes.tdStyle}>
                                {totals.deemedSgstAmount
                                  ? totals.deemedSgstAmount.toFixed(2)
                                  : '0.00'}
                              </td>
                            </>
                          ) : (
                            <>
                              <td className={classes.tdStyle}>
                                0.00
                              </td>
                              <td className={classes.tdStyle}>
                                {totals.deemedCgstAmount &&
                                totals.deemedSgstAmount
                                  ? (
                                      totals.deemedCgstAmount +
                                      totals.deemedSgstAmount
                                    ).toFixed(2)
                                  : '0.00'}
                              </td>
                            </>
                          )}
                        </>
                      )}

                      {/* Amount column for non-EMI Row 2 */}
                      {!isEMIType && (
                        <td className={classes.tdStyle}>
                          {totals.deemedAmount
                            ? totals.deemedAmount.toFixed(2)
                            : '0.00'}
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div className={classes.tophstyle}>
                    {/* Only show GSTIN if it exists */}
                    <div>
                      Total Billable Units (kWh){' '}
                      {totals.totalBillableUnits
                        ? totals.totalBillableUnits.toFixed(2)
                        : '0.00'}
                    </div>
                    <div>Total In Words</div>
                    <div
                      className={classes.Boldstyle}
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        whiteSpace: 'initial',
                      }}
                    >
                      {getCurrencyFullName(state?.data?.currency)}{' '}
                      {numberToWords.toWords(roundedTotal)}{' '}
                      {isEMIType ? 'Tariff Total' : 'Total'} Only
                    </div>

                    {/* <div
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      className={classes.Boldstyle}
                    >
                      CURRENT OUTSTANDING BALANCE :{' '}
                      {FetchCurrency(state?.data?.currency)}{' '}
                      {roundedTotal.toFixed(2)}
                    </div> */}
                    <table className={`${classes.tableStyle} print-no-border`}>
                      <tbody>
                        <tr>
                          <td>
                            <div className={classes.tdStyle}>
                              <div>
                                Name of Bank :{' '}
                                <a
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {
                                    state?.data?.clientDetails?.billerDetails
                                      ?.nameOfTheBank
                                  }
                                </a>
                              </div>
                              <div>
                                Address of Bank :{' '}
                                <a
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {
                                    state?.data?.clientDetails?.billerDetails
                                      ?.addressOfTheBank
                                  }
                                </a>
                              </div>
                              <div>
                                Account Number :{' '}
                                <a
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {
                                    state?.data?.clientDetails?.billerDetails
                                      ?.accountNumber
                                  }
                                </a>
                              </div>
                              <div>
                                IFSC Code :{' '}
                                <a
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {
                                    state?.data?.clientDetails?.billerDetails
                                      ?.ifscCode
                                  }
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      minWidth: '50%',
                      justifyContent: 'end',
                      border: '1px solid #dddddd',
                      padding: '8px',
                      textAlign: 'left',
                    }}
                  >
                    <div style={{ minWidth: '25%' }}>
                      <div>Sub Total</div>
                      {/* Only show GST rows if GSTN exists */}
                      {hasGSTN && (
                        <>
                          {isLocationMatched ? (
                            <>
                              <div>CGST (0%)</div>
                              <div>SGST (0%)</div>
                            </>
                          ) : (
                            <div>IGST (0%)</div>
                          )}
                        </>
                      )}
                      <div>Rounding</div>
                      <div
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                        className={classes.Boldstyle}
                      >
                        Total
                      </div>
                      <div
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                        className={classes.Boldstyle}
                      >
                        Balance Due
                      </div>
                    </div>

                    <div style={{ minWidth: '25%' }}>
                      <div>
                        : {FetchCurrency(state?.data?.currency)}{' '}
                        {subTotal.toFixed(2)}
                      </div>
                      {/* Only show GST amounts if GSTN exists */}
                      {hasGSTN && (
                        <>
                          {isLocationMatched ? (
                            <>
                              <div
                                style={{ fontSize: '16px', fontWeight: 'bold' }}
                                className={classes.Boldstyle}
                              >
                                : {FetchCurrency(state?.data?.currency)} 0.00
                              </div>
                              <div
                                style={{ fontSize: '16px', fontWeight: 'bold' }}
                                className={classes.Boldstyle}
                              >
                                : {FetchCurrency(state?.data?.currency)} 0.00
                              </div>
                            </>
                          ) : (
                            <div
                              style={{ fontSize: '16px', fontWeight: 'bold' }}
                              className={classes.Boldstyle}
                            >
                              : {FetchCurrency(state?.data?.currency)} 0.00
                            </div>
                          )}
                        </>
                      )}
                      <div>
                        : {FetchCurrency(state?.data?.currency)}{' '}
                        {roundingAmount.toFixed(2)}
                      </div>
                      <div
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                        className={classes.Boldstyle}
                      >
                        : {FetchCurrency(state?.data?.currency)}{' '}
                        {roundedTotal.toFixed(2)}
                      </div>
                      <div
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                        className={classes.Boldstyle}
                      >
                        : {FetchCurrency(state?.data?.currency)}{' '}
                        {roundedTotal.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Conditionally render O&M Details Page for EMI type */}
      {isEMIType && (
        <OmDetailsPage
          state={state}
          omAmounts={omAmounts}
          setOmAmounts={setOmAmounts}
          FetchCurrency={FetchCurrency}
          totals={totals}
          energyValue={energyValue}
          setEnergyValue={setEnergyValu} // Assuming this is intended
          mainEnergy={mainEnergy}
          setMainEnergy={setMainEnergy}
          mainTariff={mainTariff}
          setMainTariff={setMainTariff}
          deemedEnergy={deemedEnergy}
          setDeemedEnergy={setDeemedEnergy}
          deemedTariff={deemedTariff}
          setDeemedTariff={setDeemedTariff}
          deemedGeneration={deemedGeneration} // Keep for backward compatibility
          deemedGener={deemedGener} // ✅ ADDED - Pass the editable state value
          setDeemedGener={setDeemedGener} // ✅ ADDED - Pass the setter function
          invoiceDate={invoiceDate}
          firstDate={firstDate}
          setFirstDate={setFirstDate}
          invoiceDetails={invoiceDetails}
          handleEditClick={handleEditClick}
          months={months}
          CurrentMonth={CurrentMonth1}
          getCurrencyFullName={getCurrencyFullName}
          zohoState={zohoState}
          energyValu={energyValu} // Fixed typo here
        />
      )}
    </>
  )
}

export default InvoiceTable
